import { render, staticRenderFns } from "./ConfidenceInterval.vue?vue&type=template&id=61ebc2ca&scoped=true"
import script from "./ConfidenceInterval.vue?vue&type=script&lang=js"
export * from "./ConfidenceInterval.vue?vue&type=script&lang=js"
import style0 from "./ConfidenceInterval.vue?vue&type=style&index=0&id=61ebc2ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ebc2ca",
  null
  
)

export default component.exports